import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminBusinessLicenses = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.BUSINESS_LICENSES.GET_ALL, { params });
    return response.data;
};
export const getAdminBusinessLicenseById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.BUSINESS_LICENSES.GET_BY_ID(id));
    return response.data;
};
export const createBusinessLicense = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.BUSINESS_LICENSES.CREATE, data);
    return response.data;
};
export const updateBusinessLicense = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.BUSINESS_LICENSES.UPDATE(id), data);
    return response.data;
};
export const deleteBusinessLicense = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.BUSINESS_LICENSES.DELETE(id));
    return response.data;
};

